import React from 'react';
import './CheckoutProduct.css';
import { useStateValue } from "./StateProvider";
import { Button, Typography, Rate, InputNumber } from "antd";
import { DeleteOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function CheckoutProduct({ id, image, title, price, rating, quantity = 1, hideButton }) {
    const [{ basket, user }, dispatch] = useStateValue();

    const syncLocalStorage = (newBasket) => {
        if (user) {
            localStorage.setItem(`basket_${user.uid}`, JSON.stringify(newBasket));
        }
    };

    const addOne = () => {
        const newItem = { id, title, image, price, rating };
        dispatch({ type: "ADD_TO_BASKET", item: newItem });

        const updatedBasket = [...basket, newItem];
        syncLocalStorage(updatedBasket);
    };

    const removeOne = () => {
        dispatch({ type: 'REMOVE_FROM_BASKET', id });

        const index = basket.findIndex((item) => item.id === id);
        let newBasket = [...basket];
        if (index >= 0) {
            newBasket.splice(index, 1);
        }
        syncLocalStorage(newBasket);
    };

    const removeAll = () => {
        dispatch({ type: 'REMOVE_ALL_OF_ITEM', id });

        const newBasket = basket.filter((item) => item.id !== id);
        syncLocalStorage(newBasket);
    };

    return (
        <div className="checkoutProduct">
            <img className="checkoutProduct__image" src={image} alt={title} />
            <div className="checkoutProduct__info">
                <Title level={5} style={{ marginBottom: 4, fontSize: 14 }}>
                    {title} {hideButton && quantity > 1 && <span style={{ color: '#8c8c8c', fontWeight: 'normal' }}>(x{quantity})</span>}
                </Title>
                <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 4 }}>
                    ${price}
                </Text>
                <Rate disabled defaultValue={rating} style={{ fontSize: 12, display: 'block', marginBottom: 12 }} />

                {!hideButton && (
                    <div className="checkoutProduct__actions">
                        <div className="checkoutProduct__quantity">
                            <Button
                                size="small"
                                icon={<MinusOutlined />}
                                onClick={removeOne}
                                disabled={quantity <= 1}
                                className="checkoutProduct__qtyBtn"
                            />
                            <span className="checkoutProduct__qtyValue">{quantity}</span>
                            <Button
                                size="small"
                                icon={<PlusOutlined />}
                                onClick={addOne}
                                className="checkoutProduct__qtyBtn"
                            />
                        </div>

                        <Button
                            type="link"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={removeAll}
                            style={{ padding: 0 }}
                        >
                            Delete
                        </Button>

                        <Text type="secondary" style={{ marginLeft: 'auto', fontSize: 16, fontWeight: 600 }}>
                            ${(price * quantity).toFixed(2)}
                        </Text>
                    </div>
                )}
            </div>
        </div>
    )
}

export default CheckoutProduct;
